import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-78">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-79">
        <div className="mb-10" data-id="element-80">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 flex items-center justify-center gap-3 mb-6" data-id="element-81">
            <ShieldCheck className="w-12 h-12 text-emerald-600" data-id="element-82" />
            Garantía de Hierro de 7 Días
          </h2>
        </div>

        <div className="bg-emerald-50 border border-emerald-100 rounded-3xl p-8 md:p-10 shadow-sm" data-id="element-83">
          <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-84">
            Probá el sistema sin ningún riesgo
          </h3>
          <p className="text-slate-700 leading-relaxed mb-6 text-lg" data-id="element-85">
            Tenés 7 días completos para revisar todo el material y comprobar que
            es justo lo que te prometimos: un sistema completo, claro y listo .
            Si lo que recibís no corresponde con lo que prometemos, te
            devolvemos el 100% de tu dinero, sin vueltas y sin formularios
            complicados. Así de simple: cumplimos o te lo reintegramos.
          </p>
          <div className="inline-flex bg-white px-6 py-3 rounded-full border border-emerald-200 text-emerald-800 font-bold text-sm shadow-sm uppercase tracking-wide" data-id="element-86">
            Tu Inversión Está 100% Protegida
          </div>
        </div>
      </div>
    </section>;
}